import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { ConfiguratorRenewalInformation } from '@models';
import { PostRenewalInformationFailure, PostRenewalInformationRequest, PostRenewalInformationSuccess } from './actions';

export const featureKey = 'renewalInformation';

export interface State {
  data: ConfiguratorRenewalInformation | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PostRenewalInformationFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(PostRenewalInformationRequest, state => ({ ...state, error: null, loading: true })),
    on(PostRenewalInformationSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
